import React, { useState } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  LinearProgress,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { uploadFile } from "api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function DragDropUpload({ fair }) {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("");

  const onDrop = (acceptedFiles) => {
    setFile(acceptedFiles[0]);
    setStatus("");
    setProgress(0);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
  });

  const handleUpload = async () => {
    if (!file) return;
    console.log("_______file_____", file);

    const fileType = file?.name.split(".").pop(); // "glb"
    if (fileType != "csv") {
      setStatus("Upload only csv file");
      toast.error("Upload only csv file");
      return;
    }

    setStatus("Uploading...");
    setIsLoading(true);
    var params = {
      file: file,
    };

    const res = await uploadFile(params);

    // console.log("______res______", res);

    if (res?.data) {
      //   setStatus(`✅ Uploaded: ${res?.data?.filename}`);
      setStatus(`✅ Uploaded successfully`);
      navigate("/fair");
      setIsLoading(false);
    } else {
      setStatus("❌ Upload failed");
      setIsLoading(false);
    }
  };

  return (
    <MDBox>
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <MDTypography variant="h5" fontWeight="bold" mb={2}>
            Drag & Drop Upload
          </MDTypography>
          <MDBox>
            <Box
              {...getRootProps()}
              sx={{
                border: "2px dashed #aaa",
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                cursor: "pointer",
                bgcolor: isDragActive ? "grey.100" : "transparent",
              }}
            >
              <input {...getInputProps()} />
              {isDragActive ? (
                <MDTypography variant="caption" fontWeight="medium" noWrap>
                  {"Drop the file here..."}
                </MDTypography>
              ) : (
                <MDTypography variant="caption" fontWeight="medium" noWrap>
                  {"Drag & drop a csv file here, or click to select"}
                </MDTypography>
              )}
            </Box>

            {file && (
              <Box mt={2}>
                <Typography variant="body2">{file.name}</Typography>
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  sx={{ mt: 1, height: 8 }}
                  color="info"
                />
              </Box>
            )}

            <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2} mt={2}>
              <MDButton
                onClick={handleUpload}
                variant="gradient"
                color="info"
                fullWidth
                disabled={isLoading || !file}
              >
                {isLoading ? <CircularProgress size={24} color="light" /> : "Upload"}
              </MDButton>
            </MDBox>
            {/* <Box mt={2}>
              <Button variant="contained" onClick={handleUpload} disabled={!file}>
                Upload
              </Button>
            </Box> */}

            {status && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {status}
              </Typography>
            )}
          </MDBox>
        </MDBox>
      </Card>
    </MDBox>
  );
}

DragDropUpload.propTypes = {
  fair: PropTypes.shape({
    fairCode: PropTypes.string,
  }),
};
